export interface NetworkError {
  id: string;
  message: string;
  code?: number;
  timestamp: Date;
}

type ErrorCallback = (errors: NetworkError[]) => void;

class ErrorService {
  private errors: NetworkError[] = [];
  private listeners: ErrorCallback[] = [];
  
  subscribe(callback: ErrorCallback): () => void {
    this.listeners.push(callback);
    // Immediately call with current errors
    callback([...this.errors]);
    
    // Return unsubscribe function
    return () => {
      this.listeners = this.listeners.filter(cb => cb !== callback);
    };
  }
  
  private notifyListeners(): void {
    this.listeners.forEach(callback => callback([...this.errors]));
  }
  
  addError(message: string, code?: number): string {
    const id = Date.now().toString();
    const newError: NetworkError = {
      id,
      message,
      code,
      timestamp: new Date()
    };
    
    this.errors.push(newError);
    this.notifyListeners();
    
    return id;
  }
  
  clearError(id: string): void {
    this.errors = this.errors.filter(error => error.id !== id);
    this.notifyListeners();
  }
  
  clearAllErrors(): void {
    this.errors = [];
    this.notifyListeners();
  }
}

export const errorService = new ErrorService();
